export const themeConfig = {
  filokar: {
    name: "Filokar",
    primaryColor: "#fbe122",
    logo: "/logos/filokar.svg",
    favicon: "/favicons/filokar.ico",
    theme: "light",
    colors: {
      primarySurface: " #1d3469",
      graySurface: " #f9f9f9",
      graySelected: " #e0e0e0",
      grayHover: " #f0f0f0",
      buttonPrimaryBackground: " #4460aa",
      buttonPrimaryText: "white",
      buttonPrimaryHoverBackground: " #3a5499",
      buttonPrimaryInverseBackground: "white",
      buttonPrimaryInverseText: " #1d3469",
      buttonPrimaryInverseHoverBackground: " #1d3469",
      buttonPrimaryDangerBackground: " #830000",
      buttonPrimaryDangerText: "white",
      buttonPrimaryDangerHoverBackground: " #b30000",
      buttonPrimaryDisabledBackground: " #ccc",
      buttonPrimaryDisabledText: " #979797",
      buttonSelectedBackground: " #4460aa",
      buttonSelectedText: "white",
      link: "#3182ce",
    },
  },
  servistesin: {
    name: "Servistesin",
    primaryColor: "#009688",
    logo: "/logos/abc.svg",
    favicon: "/favicons/servistesin.ico",
    theme: "light",
    colors: {
      primarySurface: " #0b0c0b",
      graySurface: " #f9f9f9",
      graySelected: " #e0e0e0",
      grayHover: " #f0f0f0",
      buttonPrimaryBackground: " #0b0c0b",
      buttonPrimaryText: " #fbdd04",
      buttonPrimaryHoverBackground: " #000000",
      buttonPrimaryInverseBackground: "white",
      buttonPrimaryInverseText: " #0b0c0b",
      buttonPrimaryInverseHoverBackground: " #0b0c0b",
      buttonPrimaryDangerBackground: " #830000",
      buttonPrimaryDangerText: "white",
      buttonPrimaryDangerHoverBackground: " #b30000",
      buttonPrimaryDisabledBackground: " #ccc",
      buttonPrimaryDisabledText: " #979797",
      buttonSelectedBackground: " #fbdd04",
      buttonSelectedText: " #0b0c0b",
      link: "#3182ce",
    },
  },
};
